import * as THREE from 'three';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { Object3D } from "./Viewer.Object3D.js";

class Node extends Object3D {
    constructor(coords, material, labelText, fixity) {
        super();

        this.fixity = fixity;
        this.coords = coords;

        this.position.set(...coords);

        const geometry = new THREE.BufferGeometry();
        const vertex = new Float32Array([0, 0, 0]);

        geometry.setAttribute('position', new THREE.BufferAttribute( vertex, 3 ));

        this.point = new THREE.Points( geometry, material );
        this.add( this.point );

        this.label = new CSS2DObject(this.createLabelElement(labelText));
        this.add( this.label );
    }

    createLabelElement(text) {
        const div = document.createElement('div');
        div.className = 'node-label';
        div.classList.add('rounded-full');
        div.textContent = text;
        div.style.marginTop = '-1em';
        div.style.padding = '2px 4px';
        // div.style.background = 'rgba(0, 0, 0, 0.5)';
        div.style.color = 'text-base-color';
        div.style.borderWidth = '1px';
        div.style.borderColor = 'rgb(0, 0, 0)';
        div.style.fontSize = '12px';

        return div;
    }
}

export { Node };